import styled from "styled-components";

export const StyledMatchInfo = styled.div`
  width: 200px;
  align-self: flex-start;
`;

export const StyledMatchInfoTitle = styled.p`
  font-family: ${(props) => props.theme.figma.base.fontfamily_mlstifo_standard};
  font-style: normal;
  font-weight: 400;
  font-size: ${(props) => props.theme.mixins.pxToRem(11)};
  line-height: 14px;
  color: ${(props) => props.theme.figma.base.color_black_100};
  opacity: 0.4;
`;

export const StyledMatchRoundInfo = styled.p`
  font-family: ${(props) => props.theme.figma.base.fontfamily_mlstifo_standard};
  font-style: normal;
  font-weight: 400;
  font-size: ${(props) => props.theme.mixins.pxToRem(11)};
  line-height: 14px;
  color: ${(props) => props.theme.figma.base.color_black_100};
  opacity: 0.4;
  text-wrap: nowrap;
`;

export const StyledMatchInfoVenue = styled.p`
  font-family: ${(props) => props.theme.figma.base.fontfamily_mlstifo_standard};
  font-style: normal;
  font-weight: 400;
  font-size: ${(props) => props.theme.mixins.pxToRem(11)};
  line-height: 14px;
  color: ${(props) => props.theme.figma.base.color_offblack_100};
`;
